import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from 'app/state/users.repository';
import { CoachMenteeChatDto } from '../models/coachMenteeChat/coachMenteeChatDto';
import { CoachMenteeChatMessageDto } from '../models/coachMenteeChat/coachMenteeChatMessagesDto';
import { UserGroupWithUsers } from 'app/state/usergroup.repository';
import { UserUserGroupChatDto } from '../models/userUserGroupChat/userUserGroupChatDto';
import { UserUserGroupChatMessageDto } from '../models/userUserGroupChat/userUserGroupChatMessageDto';
const API = '/api/chats';
export interface CoachMenteeResponseDto {
  coaches: User[];
  mentees: User[];
}
@Injectable({
  providedIn: 'root',
})
export class CoachMenteeChatService {
  constructor(private http: HttpClient) {}
  getUsers() {
    return this.http.get<UserGroupWithUsers[]>(`${API}/my-groups-with-users`);
  }
  getOrCreateUserGroupChatWithUser(
    userId: string
  ): Observable<UserUserGroupChatDto> {
    return this.http.get<UserUserGroupChatDto>(
      `${API}/usergroup/with-user/${userId}`
    );
  }
  getAllMessagesForUserGroup(): Observable<UserUserGroupChatDto[]> {
    return this.http.get<UserUserGroupChatDto[]>(`${API}/usergroup/messages`);
  }
  getUserGroupMessagesByChatId(
    chatId: string
  ): Observable<UserUserGroupChatMessageDto[]> {
    return this.http.get<UserUserGroupChatMessageDto[]>(
      `${API}/usergroup/messages/${chatId}`
    );
  }
  createReplyGroupMessage(dto: UserUserGroupChatMessageDto): Observable<void> {
    return this.http.post<void>(`${API}/usergroup/message/reply`, dto);
  }
  createUserGroupChatMessage(
    getterId: string,
    dto: Partial<UserUserGroupChatMessageDto>
  ) {
    return this.http.post(`${API}/usergroup/message/${getterId}`, dto);
  }
  editUserGroupMessage(message: UserUserGroupChatMessageDto): Observable<void> {
    return this.http.put<void>(
      `${API}/usergroup/message/${message.id}`,
      message
    );
  }
  deleteUserGroupMessage(messageId: string): Observable<void> {
    return this.http.delete<void>(`${API}/usergroup/message/${messageId}`);
  }
  ////////////////////////////////////
  getOrCreateChatWithUser(userId: string): Observable<CoachMenteeChatDto> {
    return this.http.get<CoachMenteeChatDto>(`${API}/with-user/${userId}`);
  }
  getAllMessagesForUser(): Observable<CoachMenteeChatDto[]> {
    return this.http.get<CoachMenteeChatDto[]>(`${API}/messages`);
  }
  getCoachMenteeList(): Observable<CoachMenteeResponseDto> {
    return this.http.get<CoachMenteeResponseDto>(`${API}/coach/relationships`);
  }

  getCoachMenteeMessagesByChatId(
    chatId: string
  ): Observable<CoachMenteeChatMessageDto[]> {
    return this.http.get<CoachMenteeChatMessageDto[]>(
      `${API}/messages/${chatId}`
    );
  }

  createChatMessage(getterId: string, dto: Partial<CoachMenteeChatMessageDto>) {
    return this.http.post(`${API}/message/${getterId}`, dto);
  }

  createReplyMessage(dto: CoachMenteeChatMessageDto): Observable<void> {
    return this.http.post<void>(`${API}/message/reply`, dto);
  }

  editMessage(message: CoachMenteeChatMessageDto): Observable<void> {
    return this.http.put<void>(`${API}/message/${message.id}`, message);
  }
  deleteMessage(messageId: string): Observable<void> {
    return this.http.delete<void>(`${API}/message/${messageId}`);
  }
}
